module.exports = __webpack_public_path__ + "img/teamImg23.a47f1668.jpg";